import {Stack, Text, Title} from '@mantine/core';
import React from 'react';

import BackLink from './BackLink';
import {SIGNUP_BACK_HEADER_STACK_SPACING, SIGNUP_HEADER_STACK_SPACING, useSignupStepStyles} from './signupUi';

interface SignupStepHeaderProps {
  backLabel?: string;
  onBack: () => void;
  subtitle?: React.ReactNode;
  title: string;
}

export default function SignupStepHeader({
  backLabel = 'Back',
  onBack,
  subtitle,
  title,
}: SignupStepHeaderProps): JSX.Element {
  const {classes} = useSignupStepStyles();

  return (
    <Stack spacing={SIGNUP_BACK_HEADER_STACK_SPACING}>
      <BackLink label={backLabel} onClick={onBack} />
      <Stack spacing={SIGNUP_HEADER_STACK_SPACING}>
        <Title order={2}>{title}</Title>
        {subtitle != null && <Text className={classes.subtitle}>{subtitle}</Text>}
      </Stack>
    </Stack>
  );
}
